// src/components/imagepicker/PreviewCard.jsx
import React from "react";
import {
    Card,
    CardMedia,
    IconButton,
    Box,
    Typography,
    Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from "@mui/icons-material/Star";
import styles from "./styles/styles.module.scss";

export default function PreviewCard({
    src,
    label,
    thumbHeight = 220,
    isPrimary = false,
    uploading = false,
    onRemove,
    onMakePrimary,
}) {
    const noImage = !src;

    return (
        <Card
            className={[
                styles.card,
                noImage ? styles.noImage : "",
                uploading ? styles.uploading : "",
            ].join(" ")}
        >
            {!noImage ? (
                <CardMedia
                    component="img"
                    image={src}
                    className={styles.thumb}
                    sx={{
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                        maxHeight: 180,
                    }}
                />
            ) : (
                <Box
                    className={`${styles.thumb} ${styles.thumbAlt}`}
                    sx={{ height: thumbHeight }}
                >
                    <Typography variant="caption">No image</Typography>
                </Box>
            )}

            {isPrimary && <Box className={styles.primaryBadge}>primary</Box>}

            <IconButton
                className={styles.removeBtn}
                onClick={onRemove}
                size="small"
                aria-label="Видалити зображення"
                disabled={uploading}
                sx={{
                    color: "#000",
                    "&:hover": { color: "#000" },
                }}
            >
                <DeleteIcon fontSize="small" sx={{ color: "#000" }} />
            </IconButton>

            <Box className={styles.cardFooter}>
                <Typography className={styles.key} title={label}>
                    {label}
                </Typography>

                {!isPrimary && (
                    <Button
                        size="small"
                        variant="text"
                        startIcon={<StarIcon fontSize="small" sx={{ color: "#000" }} />}
                        onClick={onMakePrimary}
                        disabled={uploading}
                        className={styles.primaryBtn}
                    >
                       Головне
                    </Button>
                )}
            </Box>

            {uploading && <Box className={styles.uploadOverlay}>Uploading...</Box>}
        </Card>
    );
}